export default "__VITE_ASSET__Dnh0YfQL__"